import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { formatDate } from "../../constants/DateUtil/DateUtil";
import { Button } from "primereact/button";

export default function StoreLoadModal({
  storeLoadModalVisible,
  setStoreLoadModalVisible,
  storeLoadData,
}) {
  // useEffect(() => {
  //   if (storeLoadModalVisible) {
  //     const timer = setTimeout(() => {
  //       setStoreLoadModalVisible(false);
  //     }, 2500);

  //     return () => clearTimeout(timer); // Clear the timer if the component unmounts or modalVisible changes
  //   }
  // }, [storeLoadModalVisible, setStoreLoadModalVisible]);

  const handleModalClose = () => {
    setStoreLoadModalVisible(false);
  };

  const totalData = storeLoadData?.loadData?.reduce(
    (acc, item) => acc + item.loadCount,
    0
  );

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={storeLoadModalVisible}
        style={{ width: "50vw", }}
        onHide={() => {
          if (!storeLoadModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
              height:"40vh"
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <div></div>

              <div>
                <div>
                  <div className="flex flex-column justify-content-center align-items-center gap-2">
                    <div className="flex justify-content-center align-items-center gap-2">
                      <p className="text-white-alpha-90 text-3xl text-primary-50 font-semibold">
                        {storeLoadData?.loadData?.length > 0 ? "" : "No"}{" "}
                        Upcoming Delivery On - {formatDate(storeLoadData?.date)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <Button
                label="x"
                onClick={() => handleModalClose()}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>
            {/* <div className="flex flex-column justify-content-center align-items-center gap-2">
              {storeLoadData?.loadData?.map((item) => (
                <div className="flex justify-content-center align-items-center gap-2">
                  <p className="text-black-alpha-90 text-2xl text-primary-50 font-semibold">
                    {item.service} - {item.loadCount}
                  </p>
                </div>
              ))}
            </div> */}
            <div
              className="h-20rem scroll-bar mb-2"
              style={{
                overflowY: "scroll",
              }}
            >
            <div className="grid mt-1 mx-3 justify-content-center">
              {storeLoadData?.loadData?.map((item) => (
                <div className="mx-3">
                <p className=" text-center text-lg font-semibold capitalize">
                    {item.service}
                  </p>
                  <div
                    className=" surface-0 border-round-md"
                    style={{
                      backgroundImage:
                        "radial-gradient(circle at left top, #1752AA, #2B70D7)",
                    }}
                  >
                    <p className="text-white text-center text-lg font-semibold capitalize">
                      {item.loadCount}
                    </p>
                  </div>
                 
                </div>
              ))}
            </div>
            <div className="flex-1 my-3 mx-4">
            <div className="flex flex-column justify-content-center align-items-center gap-2">
                    <div className="flex justify-content-center align-items-center gap-2">
                      <p className="text-black-alpha-90 text-2xl text-primary-50 font-semibold">
                         {totalData > 0 ? "Total - " + totalData : "" }
                      </p>
                    </div>
                  </div>
            </div>
            </div>
          </div>
        )}
      ></Dialog>
    </div>
  );
}
